import { createElement } from 'react';
import ReactDOM from 'react-dom';
import { isString, isNode } from '@jupiter-app/utils';

const createRoot =
  (ReactDOM as any).createRoot?.bind(ReactDOM) ||
  (ReactDOM as any).unstable_createRoot?.bind(ReactDOM);

export default function bootstrap(
  AppComponment: React.ComponentType<any>,
  rootElement: any,
): React.ComponentType<any> | void {
  // node ssr
  if (isNode) {
    return AppComponment;
  }

  if (isString(rootElement)) {
    rootElement = document.getElementById(rootElement);
  }

  const ssrReturnPlugin = window?.__SPECIALHOOK__?.['@jupiter-app/plugin-ssr'];

  if (ssrReturnPlugin?.onBootStrap) {
    return ssrReturnPlugin.onBootStrap(AppComponment, rootElement);
  }

  if (createRoot) {
    createRoot(rootElement).render(createElement(AppComponment));
  } else {
    ReactDOM.render(createElement(AppComponment), rootElement);
  }
}
